import { BlazeMark } from "../components/Panel.js";

export function OfflineScreen() {
  return (
    <div className="min-h-dvh shell-surface px-[var(--spacing-gutter)] py-8 max-w-md mx-auto flex flex-col justify-center">
      <BlazeMark solid className="mb-4" />
      <h1 className="font-display text-[28px] text-granite-900 dark:text-granite-50 mb-2">
        Off the trail
      </h1>
      <p className="font-text text-granite-600 dark:text-granite-300 mb-6 leading-relaxed">
        You're offline. Sign-in and household changes need a connection.
        Offline practice arrives in the next phase.
      </p>
      <p className="font-text text-[15px] text-granite-500 dark:text-granite-400">
        Reconnect, then try again. Your progress is safe.
      </p>
    </div>
  );
}
